export const environment = {
  production: false,
  tenant: 'adwwncscdev001',
  tenantId: 'eb1d5e64-381a-4933-be32-eedda09e01ea',
  clientId: '6ae374d2-de8b-40c8-b84c-a073411aab86',
  redirectUrl: 'https://stwwncscwebdev001.z1.web.core.windows.net',
  apiScope: 'a4b7e1d7-0db2-41e1-b02b-8b9dd4e67626/Projects.Write',
  offerApiUrl: 'https://api-wwn-cs-offer-dev-001.azurewebsites.net/api',
  catalogApiUrl: 'https://api-wwn-cs-catalog-dev-001.azurewebsites.net/api'
};
